import { Check } from "lucide-react";
import { Reveal, Overline, scrollToHash } from "./shared";

const PRESTATIONS = [
  "Nettoyage des halls d'entrée",
  "Nettoyage des cages d'escalier",
  "Entretien des ascenseurs et surfaces accessibles",
  "Vitres et portes vitrées",
  "Entretien des locaux communs",
  "Caves et locaux techniques accessibles",
  "Gestion et entretien des zones poubelles",
  "Entretien des accès extérieurs",
  "Balayage et soufflage des abords, au calme grâce aux machines sur batteries",
  "Petites interventions courantes",
  "Remplacement de petits éléments",
  "Contrôle visuel général lors des passages",
  "Contrôle des évacuations d'eau",
  "Collaboration avec les entreprises mandatées",
  "Signalement des problèmes constatés",
];

const AUDIENCES = ["PPE", "Régies immobilières", "Propriétaires", "Immeubles résidentiels", "Locaux professionnels"];
const VALEURS = ["Régularité", "Propreté", "Réactivité", "Communication", "Sens du détail"];

export const Ppe = () => (
  <section id="entretien-ppe" className="bg-brume py-24 lg:py-36" data-testid="ppe-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-10">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <Overline>Entretien d'immeubles &amp; PPE</Overline>
            <h2 className="font-display mt-4 text-3xl font-medium leading-tight tracking-tight text-nuit sm:text-4xl lg:text-5xl">
              Un service de conciergerie fiable pour vos immeubles et PPE
            </h2>
            <p className="mt-6 text-base leading-relaxed text-nuit/65">
              Chaque immeuble est différent. Un plan d'entretien peut être défini selon sa taille,
              sa fréquentation et les attentes de la PPE ou du propriétaire — avec un interlocuteur
              unique qui connaît réellement votre bien. Lors de ses passages, Steve Rosset ne regarde
              pas uniquement la propreté : il reste attentif à l'état général de l'immeuble, signale
              les anomalies constatées et peut réaliser directement de nombreuses petites réparations
              lorsqu'elles entrent dans ses compétences.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-8 flex flex-wrap gap-2">
              {AUDIENCES.map((a) => (
                <span key={a} className="bg-white px-4 py-2 text-xs font-semibold uppercase tracking-[0.12em] text-petrole shadow-sm">
                  {a}
                </span>
              ))}
            </div>
            <p className="font-display mt-10 border-l-2 border-lagoon pl-6 text-xl font-medium leading-snug text-nuit">
              Un service impeccable et une attention portée aux détails.
            </p>
            <a
              href="/contact"
              data-testid="ppe-cta-devis"
              className="mt-10 inline-block rounded-full bg-nuit px-7 py-4 text-sm font-bold uppercase tracking-[0.12em] text-white transition-colors duration-300 hover:bg-petrole"
            >
              Demander un plan d'entretien
            </a>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <div className="grid grid-cols-1 gap-px bg-nuit/10 sm:grid-cols-2">
            {PRESTATIONS.map((p, i) => (
              <Reveal key={p} delay={Math.min(i * 0.04, 0.4)} className="bg-brume">
                <div className="flex h-full items-start gap-3 bg-white p-5 transition-colors duration-300 hover:bg-nuit hover:text-white group">
                  <Check className="mt-0.5 h-4 w-4 shrink-0 text-lagoon" />
                  <span className="text-sm font-medium leading-snug text-nuit/80 transition-colors duration-300 group-hover:text-white">{p}</span>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.15}>
            <div className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-2">
              {VALEURS.map((v, i) => (
                <span key={v} className="flex items-center gap-6 text-xs font-bold uppercase tracking-[0.2em] text-nuit/50">
                  {v}
                  {i < VALEURS.length - 1 && <span className="h-1 w-1 rotate-45 bg-lagoon" />}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
